module.exports = __webpack_public_path__ + "static/Privitar-4fe46dfa8ac2fa642df893976e64920e.jpg";